export default __webpack_public_path__ + "static/weight-b8cd41099b1e8f6f847abf52a375511d.png";